/* import __COLOCATED_TEMPLATE__ from './confirm-delete-dialog.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();